import React, { useCallback, memo, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import {useRedux} from "../../../hooks";
import {Label, Row,} from 'reactstrap';

import InputText from "../../../components/InputText";

import '../../../i18/config';
import {useTranslation} from "react-i18next";

import {
    Formik,
    Form,
    Field
} from 'formik';
import {MainUserSignUpPasskeyType, MainUserSignUpType} from "../../../redux/Main/User/types";
import {NewMainUserSignUp} from "../../../redux/Main/User/reducer";
import {SignUpFormPasskeyValidatorSchema} from "./SignUpFormPasskeyValidator";
import {setSignUpStatus} from "../../../redux/Main/User/actions";
import {getCurrentLanguage, getParentPartner} from "../../../helpers/functions";
import {browserSupportsWebAuthn} from "@simplewebauthn/browser";
import {registerPasskeyUser} from "../../../redux/Main/Login/actions";
import { GET_CSRF_TOKEN } from "../../../api/urls";
import { APIClient, setCSRFToken } from "../../../api/apiCore";

const SignUpFormPasskey = memo(() => {
    const { t } = useTranslation(['user','validator']);
    const { dispatch, useAppSelector } = useRedux();

    const isBrowserSupportsWebAuthn = browserSupportsWebAuthn();

    const { isSendSignUp } = useAppSelector(state => ({
        isSendSignUp: state.MainUser.isSendSignUp,
    }));

    useEffect(() => {
        const api = new APIClient();
        api.get(GET_CSRF_TOKEN).then((res: any) => {
            if (res && res.csrf_token) {
                setCSRFToken(res.csrf_token);
            }
        }).catch(() => {});
    }, []);

    const onDataSubmit = useCallback((formData: MainUserSignUpType) => {
        dispatch(setSignUpStatus(true));

        let params: MainUserSignUpPasskeyType = {
            email: formData.email,
            language: getCurrentLanguage()
        };

        const parentPartnerMark = getParentPartner();
        if (parentPartnerMark?.partnerCode && parentPartnerMark?.partnerCode.length > 0) {
            params = {
                ...params,
                partnerCode: parentPartnerMark.partnerCode
            };
        }

        dispatch(registerPasskeyUser(params));

    }, [dispatch]);

    return (
        <>
            { isBrowserSupportsWebAuthn &&
        <Formik
            initialValues={NewMainUserSignUp}
            validationSchema={SignUpFormPasskeyValidatorSchema}
            onSubmit={(values, actions) => {
                onDataSubmit(values);
                actions.setSubmitting(false);
            }}
            enableReinitialize={false}
        >
            {({ errors, touched, setFieldValue, getFieldProps }) => (
                <Form noValidate={true} className="customValidation">
                    <Row>
                        <div className={"mb-3" + (touched.email ? " was-validated" : '')}>
                            <Label className="form-label" htmlFor="form-email-input">E-mail</Label>
                            <Field
                                id="form-email-input"
                                name="email"
                                placeholder={t('user:enterEmail')}
                                component={InputText}
                                value={getFieldProps('email').value}
                                onChange={(value: string) => {
                                    setFieldValue('email', value);
                                }}
                                className={errors.email && touched.email && 'form-control is-invalid'}
                            />
                            {errors.email && touched.email ? (
                                <div className="invalid-feedback">
                                    {t('validator:' + errors.email)}
                                </div>
                            ) : touched.email && !errors.email ?
                                <div className="valid-feedback">
                                    {t('common:looksGood')}
                                </div>
                                : ''
                            }
                        </div>
                    </Row>

                    <div className="mb-4">
                        <p className="mb-0 fs-12 text-muted fst-italic">{t('auth:byRegisteringYouAgree')} <a href="https://marketcells.io/license" className="text-primary text-decoration-underline fst-normal fw-medium">{t('auth:termsOfUse')}</a></p>
                    </div>

                    <div className="mt-4">
                        <Button
                            type="submit"
                            disabled={isSendSignUp}
                            color="success"
                            className="w-100 btn-success mb-2">{t('auth:registerWithPasskey')}</Button>
                    </div>
                </Form>
            )}
        </Formik>
            }
        </>
    );
});

export default SignUpFormPasskey;